import GameState from "slotworks/model/game-state";
import SpinRecord from "slotworks/model/gameplay/records/spin-record";
import { Exit } from "slotworks/state-machine/data/exit";
import Decision from "slotworks/state-machine/decisions/decision";
import GatewayResult, { GatewayType } from "model/gameplay/records/results/gateway-result";

export default class CGIsFreespinsGateway extends Decision {
    public evaluate() {
        const gameplay = GameState.getCurrentGame();
        const record = gameplay.getRootRecord();

        // if (!(record instanceof SpinRecord) && record.lastChild) {
        //     record = record.parent;
        // }

        const gatewayResult = record.getResultsOfType(GatewayResult)[0];
        const isFreespinGateway = gatewayResult.gatewayType === GatewayType.FREESPINS;
        return isFreespinGateway ? Exit.True : Exit.False;
    }
}
